import React from 'react';

/**
 * Reusable labelled form input.
 *
 * Before: every modal had <label>Name<input style={inputStyle} /></label>
 * repeated for each field with identical styling.
 *
 * Props:
 *  - name, label, value, onChange  – standard input props
 *  - type          – input type (default 'text')
 *  - required      – HTML required (default false)
 *  - disabled      – HTML disabled
 *  - placeholder   – placeholder text
 *  - step          – step for number inputs
 *  - error         – error message to display
 *  - className     – extra wrapper classes
 */
export default function FormField({
  name,
  label,
  value,
  onChange,
  type = 'text',
  required = false,
  disabled = false,
  placeholder = '',
  step,
  error,
  className = '',
}) {
  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        type={type}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        step={step}
        className={`w-full px-2 py-2 text-sm border rounded box-border font-[Arial]
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}
          ${error ? 'border-red-500' : 'border-gray-300'}
          focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500`}
      />
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
}
